<template>
    <div>
        <v-alert
            v-model="alert"
            border="start"
            :type="type"
            :title="titulo"
            variant="tonal"
            closable
            class="mt-4"
        >
        {{ texto }}
        </v-alert>
    </div>
</template>
<style src="../assets/general.css"></style>
<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'info'
            },
            texto: {
                type: String,
                required: true
            },
            titulo: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                alert: true
            }
        }
    }
</script>